import './index.css';
import { SkeletonHtml } from './skeleton';

const container = document.querySelector('[data-component="studio-demo"]');
if (container) {
  const skeletonLoader = document.createElement('div');
  skeletonLoader.id = 'skeleton-loader';
  skeletonLoader.style.textAlign = 'center';

  skeletonLoader.innerHTML = SkeletonHtml;

  container.appendChild(skeletonLoader);
  import('./main').then(({ mountApp }) => {
    skeletonLoader.remove();
    mountApp(container);
  });
}
